import React from 'react';
import { Button } from 'antd';

const Link: React.FC<any> = ({ children, ...restProps }) => <Button type="link" {...restProps}>
    {children}
</Button>

export default Link;
